import React from 'react'
import { ControlledModal } from '../../layouts/components/modal'
import { useAppContext } from '../../providers/context'
import { makeRequest, showAxiosErrorAsToast } from '../../request'
import { Button } from '../../components/simple/button'
import { useShowWithPriorityIfNotShownRecently } from '../../providers/modalPriorityProvider'

export const OutOfOfficeModal: React.FC<{ message: string }> = ({ message }) => {
  const { setState } = useAppContext()
  const [loading, setLoading] = React.useState(false)
  const { active, onComplete } = useShowWithPriorityIfNotShownRecently(1000, 'outOfOfficeModal')
  return (
    <ControlledModal
      size="xs"
      onOpenChange={(o) => {
        if (!o) onComplete()
      }}
      open={active}
      title="You have out of office mode enabled"
      disabled={loading}
    >
      <div>"{message}"</div>
      <Button
        logo
        disabled={loading}
        className="self-start"
        onClick={() => {
          setLoading(true)
          makeRequest<void>('/frontend_api/editUser', { outOfOffice: false })
            .then(() => {
              setState((s) => ({
                ...s,
                user: s.user && { ...s.user, outOfOffice: undefined },
              }))
              onComplete()
            })
            .catch(showAxiosErrorAsToast)
            .finally(() => setLoading(false))
        }}
      >
        Turn off out of office mode
      </Button>
    </ControlledModal>
  )
}
